__turbopack_context__.v({
  "headline": "BoardSectionItemRichText-module-scss-module__eZL3-W__headline",
  "innerDiv": "BoardSectionItemRichText-module-scss-module__eZL3-W__innerDiv",
  "textDiv": "BoardSectionItemRichText-module-scss-module__eZL3-W__textDiv",
});
